import { BackButton, BREAKPOINTS, TextButton as Button, COLORS, ComponentL, ComponentTextStyle, HorizontalCard, HyperLink, LoadingIndicator, PageWidth, Size, SystemIcons, VerticalCard } from "@laerdal/life-react-components";

import styled from "styled-components";
import { caseTypeSubtypes } from "../../model/constants/CaseTypeSubtype";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { KnowledgeArticleListItemDto } from "../../model/dto/knowledgeArticleListItemDto";
import ArticleApi from "../../services/api/ArticleApi";
import Faqs from "../../commonComponents/Faqs";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { marketList } from "../../model/constants/marketContants";
import { selectMarket, selectTranslateWithAi } from "../../store/slices/globalConfigSlice";
import UrgentAssistance from "../../commonComponents/UrgentAssistance";
import { CaseTitle, CaseSubTitle, CaseHeader } from "./components/CommonCaseComponents";


const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 32px 0;
`;



const FullWidth = styled.div`
  border-top: 1px solid ${COLORS.neutral_200};
  background: ${COLORS.neutral_20};
`

const Options = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const Side = styled.div`
    display: flex;
    flex-direction: column;
    gap:16px;
`

const Row = styled.div`
    display: flex;
    ${BREAKPOINTS.MEDIUM}{
        flex-direction: row;
        gap:64px
    }

    flex-direction: column;
    gap:8px
`

const Link = styled(HyperLink)`
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */

    border-radius: 4px;
    border: 1px solid var(--Neutral-200-tint, #CCC);
    background: var(--Base-White, #FFF);
    padding: 12px 20px 7px 20px;

    svg {
        vertical-align: middle;
        margin: 0 8px 4px 0;
    }
`;

const StyledVerticalCard = styled(VerticalCard)`
  width: 100%;
  
    [data-testid='card-middleSection'] > div:first-child div {
        color: var(--Base-Black, #1A1A1A);
        font-feature-settings: 'liga' off;
        font-family: Lato;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }
`;

const StyledPageWidth = styled(PageWidth)`
    width: calc(100% - 32px);
    
    ${BREAKPOINTS.MEDIUM} {
        width: calc(100% - 64px);
    }

    ${BREAKPOINTS.LARGE} {
        width: 100%;
    }
`;

const CanNotSpecifyBtn = styled(Button)`
    align-self: start;
    margin: 16px 0;
`;

const UsfulArticles = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 64px;
`;

const CaseCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation("cases");


  const currentMartket = useSelector(selectMarket);


  return (
    <>
      <StyledPageWidth $useMaxWidth={true} $maxWidth={1024} $unsetMargin={true}>

        <PageContainer>
          <CaseHeader>
            <BackButton size={Size.Small} onClick={() => window.history.back()}  >
              {t('Back')}
            </BackButton>
            <CaseTitle>{t('How can we assist you today?')}</CaseTitle>
            <CaseSubTitle>{t('Choose an option below to get started.')}</CaseSubTitle>
          </CaseHeader>

          <Row>
            <Options>
              {caseTypeSubtypes.map((caseType, index) => (
                <StyledVerticalCard
                  key={index}
                  variant="outline"
                  middleSectionProps={{
                    title: "",
                    categoryIcon: caseType.icon,
                    categoryLabel: t(caseType.title),
                    description: t(caseType.subtitle)
                  }}
                  onCardClicked={() => {
                    if (caseType.subtypes.length > 1)
                      navigate(`/case/create/${caseType.value}`)
                    else if (caseType.subtypes[0].skipAssetSelection)
                      navigate(`/case/create/${caseType.value}/${caseType.subtypes[0].value}`)
                    else
                      navigate(`/case/create/${caseType.value}/assetSelect?suboption=${caseType.subtypes[0].value}`)
                  }}
                />
              ))}
              <CanNotSpecifyBtn variant="tertiary" onClick={() => navigate(`/case/create/unknown/unknown`)}>{t('Can not specify?')}</CanNotSpecifyBtn>
            </Options>
            <Side>
              <Link variant="default" href="https://laerdal.com/support/catalog/" ><SystemIcons.ShoppingCart size="24px" />{t('Shop for parts, and accessories')}</Link>
              {currentMartket == "us" &&
                <Link variant="default" href="https://laerdal.com/support/scheduled-support/" ><SystemIcons.Educator size="24px" />{t('Schedule a call with technician')}</Link>
              }
            </Side>
          </Row>
        </PageContainer>
      </StyledPageWidth>
      <FullWidth>
        <PageWidth $useMaxWidth={true} $maxWidth={1024}>
          <UrgentAssistance pageName="caseCreate" />
        </PageWidth>
      </FullWidth>
    </>);
};

export default CaseCreatePage;